 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"sections":"sections","media":"media","roof-calculation":"roof-calculation","timer":"timer","canopy-calculator":"canopy-calculator"}[chunkId]||chunkId) + "." + {"chunk-009c4748":"59eff5f5","chunk-3f109eb4":"93e9beae","chunk-34e29974":"51dad841","chunk-2e1f34cc":"2b8114ff","chunk-60a52ea8":"157547ad","chunk-41aa328d":"7a13dfd5","chunk-54dfe392":"dd470211","chunk-03a9af2a":"d0071471","chunk-07b9305c":"01444573","chunk-0aec7ed9":"e9f07056","chunk-0bf907c0":"ccae281c","chunk-0f00f10e":"5d8daaa9","chunk-118ae662":"f22fa45f","chunk-12579f98":"bfadaef9","chunk-266d7fdc":"bc1fad03","chunk-28f65674":"c9aec1fe","chunk-2d0e95c2":"a6c1b55b","chunk-5365fd9a":"5a1cda0e","chunk-79c0dc0a":"07313d26","chunk-2e01df6a":"8870136a","chunk-330499a9":"7a45cda6","chunk-2d0e9b03":"657c24a8","chunk-38f1a204":"68f3dafd","chunk-397868f6":"21c5eca2","chunk-41333f4c":"a4ef5ac5","chunk-44a07981":"6a3fd457","chunk-49586270":"43f3f2a0","chunk-4d6da205":"e2618380","chunk-51c51e1b":"33467406","chunk-54c25a07":"eb027209","chunk-55e48ccf":"47dd8cca","chunk-5d4962ab":"ddba96f9","chunk-66573925":"8ed86417","chunk-6c4976ba":"ab23328e","chunk-6cd685b0":"3e6dfc63","chunk-6e1af41f":"e26409d7","chunk-72287b2f":"6caf56ec","chunk-6769bd52":"5e294404","chunk-79126575":"e56920ec","chunk-7b41299e":"39917987","chunk-94c41fac":"bc09bca4","chunk-950f7058":"51566a04","chunk-a4ec5d54":"a50d58dc","chunk-3d1e0421":"72facb06","chunk-46b7609b":"04b1c88b","chunk-7403a385":"4c9792c6","sections":"6b30531a","chunk-af7c8014":"708859fd","chunk-b4da2b84":"07ebf317","chunk-cad28c8a":"5dbd9a1c","chunk-d3bd809c":"47b9728a","chunk-d4cc48be":"96deddf0","chunk-d99b9c76":"d58d3c81","chunk-f2ff7b42":"8a36ed17","chunk-2ca7231a":"115e014a","chunk-3bb6898d":"6ac21e6c","chunk-f92dc4c6":"bc1af869","chunk-ffac66f8":"172cda29","media":"e7f3b95a","roof-calculation":"148cb590","timer":"714a5161","canopy-calculator":"203d0451"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-009c4748":1,"chunk-3f109eb4":1,"chunk-34e29974":1,"chunk-2e1f34cc":1,"chunk-60a52ea8":1,"chunk-41aa328d":1,"chunk-54dfe392":1,"chunk-03a9af2a":1,"chunk-07b9305c":1,"chunk-0aec7ed9":1,"chunk-0bf907c0":1,"chunk-0f00f10e":1,"chunk-118ae662":1,"chunk-12579f98":1,"chunk-266d7fdc":1,"chunk-28f65674":1,"chunk-5365fd9a":1,"chunk-79c0dc0a":1,"chunk-2e01df6a":1,"chunk-330499a9":1,"chunk-38f1a204":1,"chunk-397868f6":1,"chunk-41333f4c":1,"chunk-44a07981":1,"chunk-49586270":1,"chunk-4d6da205":1,"chunk-51c51e1b":1,"chunk-54c25a07":1,"chunk-55e48ccf":1,"chunk-5d4962ab":1,"chunk-66573925":1,"chunk-6c4976ba":1,"chunk-6cd685b0":1,"chunk-6e1af41f":1,"chunk-6769bd52":1,"chunk-79126575":1,"chunk-7b41299e":1,"chunk-94c41fac":1,"chunk-950f7058":1,"chunk-a4ec5d54":1,"chunk-3d1e0421":1,"chunk-46b7609b":1,"chunk-7403a385":1,"sections":1,"chunk-af7c8014":1,"chunk-b4da2b84":1,"chunk-cad28c8a":1,"chunk-d3bd809c":1,"chunk-d4cc48be":1,"chunk-d99b9c76":1,"chunk-f2ff7b42":1,"chunk-2ca7231a":1,"chunk-3bb6898d":1,"chunk-f92dc4c6":1,"chunk-ffac66f8":1,"media":1,"roof-calculation":1,"timer":1,"canopy-calculator":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"sections":"sections","media":"media","roof-calculation":"roof-calculation","timer":"timer","canopy-calculator":"canopy-calculator"}[chunkId]||chunkId) + "." + {"chunk-009c4748":"eaf66686","chunk-3f109eb4":"6a4baec1","chunk-34e29974":"c21c2cd7","chunk-2e1f34cc":"ed1ffcbd","chunk-60a52ea8":"474d4b32","chunk-41aa328d":"3ba88db5","chunk-54dfe392":"8c151718","chunk-03a9af2a":"6d89f9c2","chunk-07b9305c":"12a4e8e1","chunk-0aec7ed9":"d5de255f","chunk-0bf907c0":"fefd985f","chunk-0f00f10e":"e16b2233","chunk-118ae662":"0e433876","chunk-12579f98":"b9df6a27","chunk-266d7fdc":"04d4b985","chunk-28f65674":"896306f0","chunk-2d0e95c2":"31d6cfe0","chunk-5365fd9a":"6aee1542","chunk-79c0dc0a":"e802d34e","chunk-2e01df6a":"e5efdf0d","chunk-330499a9":"84a6d769","chunk-2d0e9b03":"31d6cfe0","chunk-38f1a204":"e2f30f55","chunk-397868f6":"21eae111","chunk-41333f4c":"a70411e6","chunk-44a07981":"d5de255f","chunk-49586270":"571804c0","chunk-4d6da205":"a59c8c0c","chunk-51c51e1b":"a70411e6","chunk-54c25a07":"5e07c78d","chunk-55e48ccf":"65ababe8","chunk-5d4962ab":"8cf93786","chunk-66573925":"cbb5c4d0","chunk-6c4976ba":"291254b6","chunk-6cd685b0":"d5de255f","chunk-6e1af41f":"f23d0ec8","chunk-72287b2f":"31d6cfe0","chunk-6769bd52":"de88ebbd","chunk-79126575":"a70411e6","chunk-7b41299e":"d5de255f","chunk-94c41fac":"64b2340c","chunk-950f7058":"a70411e6","chunk-a4ec5d54":"bde78eb2","chunk-3d1e0421":"796bfd3b","chunk-46b7609b":"257debcf","chunk-7403a385":"7ea3136e","sections":"59a37108","chunk-af7c8014":"9d595533","chunk-b4da2b84":"e631ccef","chunk-cad28c8a":"3a02ae43","chunk-d3bd809c":"5c21da4f","chunk-d4cc48be":"ebef3671","chunk-d99b9c76":"8e312fce","chunk-f2ff7b42":"0b4b98f3","chunk-2ca7231a":"d2920334","chunk-3bb6898d":"9a004fac","chunk-f92dc4c6":"c71542b1","chunk-ffac66f8":"db86a14f","media":"cdde5a19","roof-calculation":"1fb790b0","timer":"381c2fef","canopy-calculator":"a4b78fda"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
